import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import cm from 'helpers/commons';
import toastr from 'helpers/toastr';
import { Modal, Button, Item, Form, TextArea } from 'semantic-ui-react';

const propTypes = {
  // modalFn: PropTypes.object.isRequired
};

const defaultProps = {
  billDtl: null,
  modalFn: {}
};

class StatusControlModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeIndex: 1,
      inputValue: ''
    };
  }

  handleClick = () => {
    const { inputValue } = this.state;
    const { modalFn, modalIf, billAccepted, billRejected, billParentRejected, userInfo, iIdx } = this.props;
    const { btnName, stepNumber } = modalFn;
    const { parentApproval } = modalIf;
    const { id } = userInfo;

    if (btnName === 'REJECT BUTTON' || btnName === 'PARENT REJECT BUTTON') {
      if (inputValue.trim().length === 0) {
        toastr('top-right', 'warning', '반려사유를 입력해주세요.');
        return;
      }
      if (parentApproval && parentApproval.isParentGroup && btnName === 'PARENT REJECT BUTTON') {
        billParentRejected(inputValue, iIdx, stepNumber);
      } else {
        billRejected(id, inputValue, iIdx, stepNumber);
      }
    } else {
      billAccepted('post', id, iIdx, stepNumber);
    }
  };

  changeValue = (e) => {
    const { value } = e.target;

    if (value.length > 200) {
      toastr('top-right', 'warning', '200자 이하로 입력해주세요.');
      return;
    }

    this.setState({ inputValue: value });
  };

  render() {
    const { inputValue } = this.state;
    const { modalFn, modalIf, userInfo } = this.props;
    const { open, close, btnName } = modalFn;
    const { start, end, range, format, salesSum, companySum, parentApproval } = modalIf;
    console.log(btnName);
    const acceptComponent = (
      <Modal.Content>
        <StyledItemGroup>
          <Item>
            <StyledItemHeader>청구 기간</StyledItemHeader>
            <Item.Content>
              {start}
              부터 {end}
              까지
            </Item.Content>
          </Item>
          <Item>
            <StyledItemHeader>청구범위</StyledItemHeader>
            <Item.Content>{range}</Item.Content>
          </Item>
          <Item>
            <StyledItemHeader>회사식대 총액</StyledItemHeader>
            <Item.Content>
              {cm.numberComma(salesSum)}
              {format}
              {format === '장' ? `(${cm.numberComma(companySum)}원)` : null}
            </Item.Content>
          </Item>
        </StyledItemGroup>
        <StyledP>* 청구서를 승인하면 취소할 수 없습니다.</StyledP>
      </Modal.Content>
    );

    const rejectComponent = (
      <Modal.Content>
        <StyledItemGroup>
          <Item>
            <StyledItemHeader>결재자</StyledItemHeader>
            <Item.Content>
              {parentApproval.isParentGroup
                ? parentApproval.parentApprovalUser
                : userInfo.name + '(' + userInfo.signId + ')'}
            </Item.Content>
          </Item>
          <Item>
            <StyledItemHeader>청구범위</StyledItemHeader>
            <Item.Content style={{ maxWidth: 530 }}>{range}</Item.Content>
          </Item>
          <Item>
            <StyledItemHeader>회사식대 총액</StyledItemHeader>
            <Item.Content>
              {cm.numberComma(salesSum)}
              {format}
              {format === '장' ? `(${cm.numberComma(companySum)}원)` : null}
            </Item.Content>
          </Item>
          <Item>
            <StyledItemHeader>반려사유</StyledItemHeader>
            <Item.Content>
              <Form>
                <TextArea
                  rows={2}
                  placeholder="200자 이하로 입력해주세요."
                  value={inputValue}
                  onChange={this.changeValue}
                />
              </Form>
            </Item.Content>
          </Item>
        </StyledItemGroup>
        <StyledP>* 청구서를 반려하면 취소할 수 없습니다.</StyledP>
      </Modal.Content>
    );

    return (
      <Modal className="" open={open} onClose={close} size={'small'}>
        <Modal.Header>
          {btnName === 'REJECT BUTTON' || btnName === 'PARENT REJECT BUTTON' ? '청구서 반려' : '청구서 승인'}
        </Modal.Header>

        {btnName === 'REJECT BUTTON' || btnName === 'PARENT REJECT BUTTON' ? rejectComponent : acceptComponent}

        <Modal.Actions>
          <Button inverted color="grey" onClick={close} content="취소" />
          <Button
            color={btnName === 'REJECT BUTTON' || btnName === 'PARENT REJECT BUTTON' ? 'red' : 'green'}
            content={btnName === 'REJECT BUTTON' || btnName === 'PARENT REJECT BUTTON' ? '청구서 반려' : '청구서 승인'}
            onClick={this.handleClick}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

const StyledItemGroup = styled(Item.Group)`
  padding: 1rem;
  margin-bottom: 0 !important;
  color: #2f323b;
`;

const StyledItemHeader = styled(Item.Header)`
  width: 111px;
  font-weight: bold;
`;

const StyledP = styled.p`
  padding: 1rem;
  /* margin-top: 16px; */
  color: #2f323b;
`;

StatusControlModal.propTypes = propTypes;
StatusControlModal.defaultProps = defaultProps;

export default StatusControlModal;
